function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PermissionStatus } from "expo-modules-core";
import { useState } from "react";
import { Linking } from "react-native";
import { authClient } from "./auth";
import { ConfirmationModal } from "../components/ConfirmationModal";
import { manifest } from "../constants";
import { useAppState } from "../hooks/useAppState";
import { addBreadcrumb } from "./log";
function PermissionDeniedRecoveryModal(param) {
    var permission = param.permission, factory = param.factory, response = param.response, onFinalResponse = param.onFinalResponse, onOpenSettings = param.onOpenSettings, onCloseSettings = param.onCloseSettings;
    var canAskAgain = response.canAskAgain;
    useAppState(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(appState) {
            var result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(appState === 'active')) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            onCloseSettings === null || onCloseSettings === void 0 ? void 0 : onCloseSettings()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            factory()
                        ];
                    case 2:
                        result = _state.sent();
                        onFinalResponse(result);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(appState) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        visible: true,
        title: "".concat(permission, " permission needed"),
        confirmText: canAskAgain ? 'Ask me again' : 'Go to settings',
        confirmTestID: "PermissionDeniedRecoveryModal_goToSettingsButton",
        cancelText: "Deny",
        cancelTestID: "PermissionDeniedRecoveryModal_denyButton",
        description: canAskAgain ? "You've previously denied this permission. To use this feature, please allow ".concat(manifest.name, " access.") : "It looks like you've previously denied this permission.\n\nIn order to use this feature, please enable the permission on the settings screens and return to ".concat(manifest.name, ' by clicking "back" at the top of the screen.'),
        onCancel: function() {
            return onFinalResponse(response);
        },
        onConfirm: /*#__PURE__*/ _async_to_generator(function() {
            var newResult;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!canAskAgain) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            askAsync(permission, factory, {
                                retryIfDenied: false
                            })
                        ];
                    case 1:
                        newResult = _state.sent();
                        onFinalResponse(newResult);
                        return [
                            3,
                            5
                        ];
                    case 2:
                        return [
                            4,
                            onOpenSettings === null || onOpenSettings === void 0 ? void 0 : onOpenSettings()
                        ];
                    case 3:
                        _state.sent();
                        addBreadcrumb({
                            category: 'permissions',
                            message: 'open-native-settings',
                            data: {
                                permission: permission
                            }
                        });
                        return [
                            4,
                            Linking.openSettings()
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })
    });
}
var IntitialContext = {
    permission: undefined
};
var setContext;
export function askAsync(permission, factory, _) {
    return _askAsync.apply(this, arguments);
}
function _askAsync() {
    _askAsync = _async_to_generator(function(permission, factory, param) {
        var _param_retryIfDenied, retryIfDenied, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param_retryIfDenied = param.retryIfDenied, retryIfDenied = _param_retryIfDenied === void 0 ? false : _param_retryIfDenied;
                    global.pauseAppState = true;
                    // since AppState is paused, createSessionTimeoutNavigator doesn't get notified of the inactive
                    // state when opening up the system modal and therefore doesn't update lastSeen, when coming back
                    // due to the async nature of restoring appState, we may restore pauseAppState before checking
                    // lastSeen for purposes of triggering reauthentication
                    // https://github.com/ouihealth/oui/issues/917
                    authClient.setLastSeen();
                    return [
                        4,
                        factory()
                    ];
                case 1:
                    result = _state.sent();
                    // Native permission dialogs can emit delayed AppState events after the request resolves.
                    setTimeout(function() {
                        global.pauseAppState = false;
                    }, 500);
                    addBreadcrumb({
                        category: 'permissions',
                        message: 'ask',
                        data: {
                            permission: permission,
                            result: result
                        }
                    });
                    if (result.status === PermissionStatus.DENIED && retryIfDenied) {
                        return [
                            2,
                            new Promise(function(resolve) {
                                setContext({
                                    permission: permission,
                                    factory: factory,
                                    response: result,
                                    onFinalResponse: function(final) {
                                        addBreadcrumb({
                                            category: 'permissions',
                                            message: 'final-response',
                                            data: {
                                                permission: permission,
                                                result: final
                                            }
                                        });
                                        setContext({
                                            permission: undefined
                                        });
                                        resolve(final);
                                    }
                                });
                            })
                        ];
                    }
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _askAsync.apply(this, arguments);
}
export function PermissionsManagerProvider(param) {
    var children = param.children, onOpenSettings = param.onOpenSettings, onCloseSettings = param.onCloseSettings;
    var context;
    var ref;
    ref = _sliced_to_array(useState(IntitialContext), 2), context = ref[0], setContext = ref[1], ref;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            children,
            context.permission ? /*#__PURE__*/ _jsx(PermissionDeniedRecoveryModal, _object_spread_props(_object_spread({}, context), {
                onOpenSettings: onOpenSettings,
                onCloseSettings: onCloseSettings
            })) : null
        ]
    });
}
